/* import __COLOCATED_TEMPLATE__ from './error-banner.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import { DeduplicatedAsyncData } from 'embercom/resources/utils/async-data';
import type ApiErrorSummary from 'embercom/models/standalone/api-error-summary';
import type RouterService from '@ember/routing/router-service';

export interface Args {}

export default class StandaloneErrorBanner extends Component<Args> {
  @service declare appService: { app: { id: string; isStandaloneApp: boolean } };
  @service declare router: RouterService;
  @service declare store: Store;

  dataLoader = DeduplicatedAsyncData(
    this,
    () => [this.app.id],
    async (appId) => {
      return (
        this.store.peekRecord('standalone/api-error-summary', appId) ||
        this.store.findRecord('standalone/api-error-summary', appId)
      );
    },
  );

  get app() {
    return this.appService.app;
  }

  get errorSummary(): ApiErrorSummary | undefined {
    return this.dataLoader.value;
  }

  get shouldShowBanner(): boolean {
    if (!this.app.isStandaloneApp) {
      return false;
    }

    if (
      this.router.currentRouteName === 'apps.app.loading' ||
      this.router.currentRouteName === 'apps.app.copilot-frame'
    ) {
      return false;
    }

    return this.errorSummary?.hasRecentError || false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::ErrorBanner': typeof StandaloneErrorBanner;
    'standalone/common/error-banner': typeof StandaloneErrorBanner;
  }
}
